/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./appcenter.vue?vue&type=template&id=1ef8d8fc&scoped=true"
import script from "./appcenter.vue?vue&type=script&lang=js"
export * from "./appcenter.vue?vue&type=script&lang=js"
import style0 from "./appcenter.vue?vue&type=style&index=0&id=1ef8d8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef8d8fc",
  null
  
)

export default component.exports